/** Company settings' own views, `/company/<tab>`; the bare path redirects to the first tab the user may open. */
export const COMPANY_TABS = ['details', 'accounts'] as const;
export type CompanyTab = (typeof COMPANY_TABS)[number];

export const COMPANY_TAB_LABELS: Record<CompanyTab, string> = { details: 'Details', accounts: 'Accounts' };

/** The permission that opens each tab. Finance holds only the accounts one, so it never sees Details. */
export const COMPANY_TAB_PERMISSIONS: Record<CompanyTab, string> = { details: 'configuration.manage', accounts: 'company_account.manage' };

export function companyTabPath(tab: CompanyTab): string {
  return `/company/${tab}`;
}
